import { render, staticRenderFns } from "./consumeGiveList.vue?vue&type=template&id=4164c104&scoped=true&"
import script from "./consumeGiveList.vue?vue&type=script&lang=js&"
export * from "./consumeGiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4164c104",
  null
  
)

export default component.exports